import getConfig from "next/config";
import Link from "next/link";
import classNames from "classnames";

import Alert from "@components/Alert";
import { resizeImage } from "@lib/helpers";
import Heading from "@components/Heading";

const {
  publicRuntimeConfig: {
    settings: { baseUrl, websiteName },
  },
} = getConfig();

const ScrollableSubcategories = ({ subcategories }) => {
  if (subcategories && subcategories.length > 0) {
    return (
      <ul
        className={`flex md:flex-wrap -mx-1 md:-mx-2 pt-6 pb-3 md:pb-6 overflow-x-scroll md:overflow-x-auto scrollbar ${
          websiteName === "bricostore"
            ? "scrollbar-thumb-red-brand"
            : "scrollbar-thumb-filterYellow"
        } scrollbar-track-[#F1F1F1] scrollbar-thumb-rounded-full scrollbar-track-rounded-full scrollbar-h-1`}
      >
        {subcategories.map((subcategory) => (
          <li className="p-1 md:p-2" key={subcategory.id}>
            {subcategory.url_absolute ? (
              <a
                href={subcategory.url_absolute}
                title=""
                className={classNames(
                  "bg-white min-h-[200px] rounded-lg w-[140px] md:w-[180px] flex flex-col items-center justify-center space-y-4 h-full text-center",
                  {
                    "border border-gray-1100 hover:shadow-mixRedYellow":
                      websiteName !== "bricostore",
                    "shadow-raised sm:hover:shadow-raised-hover":
                      websiteName === "bricostore",
                  }
                )}
              >
                {subcategory.thumbnail && (
                  <img
                    src={resizeImage(subcategory.thumbnail, "300x300")}
                    className="flex-none w-[100px] h-[100px] md:w-[110px] md:h-[110px] mx-auto"
                    alt={subcategory.seo_alt_text || subcategory.name}
                  />
                )}

                <Heading
                  as="h2"
                  display="h4"
                  title={subcategory.name}
                  classesProp="break-words line-clamp-2 max-w-[120px] md:max-w-[140px] leading-[22px] text-lg -tracking-1"
                />
              </a>
            ) : (
              <Link href={`${baseUrl}/${subcategory.url_key}/cpl/`}>
                <a
                  className={classNames(
                    "bg-white rounded-lg md:w-[180px] flex flex-col items-center justify-center space-y-4 h-full text-center w-[140px] min-h-[200px]",
                    {
                      "border border-gray-1100 hover:shadow-mixRedYellow":
                        websiteName !== "bricostore",
                      "shadow-raised sm:hover:shadow-raised-hover":
                        websiteName === "bricostore",
                    }
                  )}
                >
                  {subcategory.thumbnail && (
                    <img
                      src={resizeImage(subcategory.thumbnail, "300x300")}
                      className="flex-none w-[100px] h-[100px] md:w-[110px] md:h-[110px] mx-auto"
                      alt={subcategory.seo_alt_text || subcategory.name}
                    />
                  )}

                  <Heading
                    as="h2"
                    display="h4"
                    title={subcategory.name}
                    classesProp="break-words line-clamp-2 max-w-[120px] md:max-w-[140px] leading-[22px] text-lg -tracking-1"
                  />
                </a>
              </Link>
            )}
          </li>
        ))}
      </ul>
    );
  }

  return (
    <Alert type="info" showIcon>
      Nu exista subcategorii
    </Alert>
  );
};
export default ScrollableSubcategories;
